import { render, staticRenderFns } from "./ChatWindowSettings.vue?vue&type=template&id=10bc1378"
import script from "./ChatWindowSettings.vue?vue&type=script&lang=js"
export * from "./ChatWindowSettings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports